<template>
  <div class="my-favorites">
    <sidebar class="my-favorites__sidebar"></sidebar>
    <dashboard-creator-name
      class="my-favorites__creator-name"
    ></dashboard-creator-name>
    <view-owned-blueprints
      :assets="assets"
      :total-assets-count="totalAssetsCount"
      class="my-favorites__my-favorites"
      @update:number="loadMore()"
    ></view-owned-blueprints>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ViewOwnedBlueprints from '@/components/owned_blueprints/sections/ViewOwnedBlueprints';
import Sidebar from '@/components/sidebar/index';
import DashboardCreatorName from '@/components/dashboard/sections/DashboardCreatorName';

import { addErrorNotification } from '@/lib/notifications';
import Assets from '@/services/assets';

export default {
  name: 'Index',
  components: { ViewOwnedBlueprints, Sidebar, DashboardCreatorName },
  data() {
    return {
      page: 1,
      limit: 9,
      assets: [],
      totalAssetsCount: 0,
    };
  },
  computed: mapGetters('pagination', {
    getAssetsNumber: 'getAssetsNumber',
  }),
  created: function() {
    this.getAssets({
      page: this.page,
      limit: this.limit,
    });
  },
  methods: {
    ...mapActions('pagination', {
      showMoreAssets: 'showMoreAssets',
      getAssetsNumber: 'getAssetsNumber',
    }),
    loadMore() {
      this.showMoreAssets();
      this.page = this.page + 1;
      this.getAssets({
        page: this.page,
        limit: this.limit,
      });
    },
    showNumbAssets() {
      return this.getAssetsNumber;
    },
    async getAssets({ page = 1, limit = 9 }) {
      try {
        let response = await Assets.getPurchased({
          page: page,
          limit: limit,
        });
        this.assets = [...this.assets, ...response.data.rows];
        this.totalAssetsCount = response.data.count;

      } catch (error) {
        console.log(error);
        addErrorNotification('Error fetching assets.');
        return;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.my-favorites {
  @include main-grid-container;
  &__sidebar {
    grid-column: col-start / span 3;
    grid-row: auto;
  }
  &__creator-name {
    grid-column: col-start 4 / 13;
    grid-row: auto;
    position: relative;
    @media (max-width: $sm-up) {
      .dashboard-container__creator-name {
        display: none;
      }
    }
  }
  &__my-favorites {
    margin-top: -800px;
    position: relative;
    grid-column: col-start 4 / 13;
    grid-row: auto;
    background: $white-main;
    height: auto;
    @media (max-width: $sm-up) {
      grid-column: col-start / 13;
      margin-top: 0;
      margin-bottom: 20%;
    }
  }
}
</style>
